import Modal from 'components/Modal/Modal'
import * as fields from '../utils/fields'
import React, { useState } from 'react'
import * as exp from 'utils/validation'

interface CourierModalProps {
  initialForm?: order.Courier
  saveForm: (form: order.Courier) => void
  onClose: base.BasicFunc
}

const CourierModal: React.FC<CourierModalProps> = ({ initialForm, saveForm, onClose }) => {
  const [values, setValues] = useState<order.Courier>(initialForm || {} as order.Courier)
  const [errors, setErrors] = useState<Partial<order.Courier>>({})
  const validateForm = () => {
    const isZipOk = exp.final.zip.test(values.zip)
    const isPhoneOk = exp.final.phone.test(values.phone)
    if (isZipOk && isPhoneOk && values.city && values.estate_number && values.street) {
      saveForm(values)
      onClose()

    } else {
      setErrors({
        name: values.name ? undefined : 'Musisz wpisać nazwę',
        street: values.street ? undefined : 'Brakuje nazwy ulicy',
        city: values.city ? undefined : 'Brakuje nazwy miasta',
        zip: values.zip ? isZipOk ? undefined : 'Niewłaściwy kod pocztowy' : 'Brakuje kodu pocztowego',
        phone: values.phone ? isPhoneOk ? undefined : 'Niewłaściwy numer telefonu' : 'Brakuje numeru telefonu',
        estate_number: values.estate_number ? undefined : 'Brakuje numeru ulicy',
      })
    }
  }

  return (
    <Modal
      title='Dane dla kuriera'
      primaryButton='Zapisz'
      secondaryButton='Anuluj'
      primaryButtonAction={validateForm}
      secondaryButtonAction={onClose}
      onClose={onClose}>
      <div className='modal__form'>
        {fields.company.map(({ key, placeholder, label, readOnly }) => <div
          key={key}
          className='myInput'>
          <label>{errors[key] || label}</label>
          <input
            type='text'
            readOnly={readOnly}
            placeholder={placeholder}
            value={values[key] || ''}
            className={errors[key] ? 'error' : ''}
            onChange={e => {
              const { value } = e.target
              if (key !== 'zip' || !value || exp.initial.zip.test(value)) {
                setValues(prev => ({ ...prev, [key]: value }))
              }
            }}
          />
        </div>)}
      </div>
    </Modal>
  )
}

export default CourierModal